import cloneDeep from 'lodash/cloneDeep'
import type { OptionsDocument } from 'paintscout'
import { uuid } from '../../util'

export function copyPipeline(args: { options: OptionsDocument; key: string }): OptionsDocument {
  const { options, key } = args
  const { pipelines } = options.options

  const newItem = cloneDeep(pipelines.values[key])
  newItem.key = uuid()
  newItem.label = `${newItem.label} (copy)`

  const order = pipelines.order
  const orderIndex = order.indexOf(key)
  if (orderIndex !== -1) {
    order.splice(orderIndex + 1, 0, newItem.key)
  } else {
    order.push(newItem.key)
  }

  return {
    ...options,
    options: {
      ...options.options,
      pipelines: {
        ...pipelines,
        order,
        values: {
          ...(pipelines?.values ?? {}),
          [newItem.key]: newItem
        }
      }
    }
  }
}
